import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'; 
import './Authentication.module.scss';

/**
 * Import components
 */

import Loader from 'components/Loading/Loader';

/**
 * Retrieve a part of the store
 */

const mapStateToProps = (state) => {
    return {
        isInitialised: state.authentication.isInitialised
    };
};

/**
 * Inject actions into the components
 */

import retrieveAuthenticatedUser from 'actions/authentication/retrieve';
import { throws } from 'assert';

const mapDispatchToProps = {
    retrieveAuthenticatedUser
};

class Authentication extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidMount() {
        this.props.retrieveAuthenticatedUser()
        .catch((Error) => {
            //catch unauthenticated error
        });
    }

    componentDidCatch(error, info) {

        this.setState({ error });
        
        // eslint-disable-next-line no-console
        console.error(error, info);

    }

    forceReload() {
        window.location.href = '/';
    }

    render() {
        if(!this.props.isInitialised) {
            return <Loader />;
        }
        
        if (this.state.error) {
            //render fallback UI
            return (
                <div styleName='error-wrapper'>
                <h1>Oeps, er ging iets mis...</h1>
                <h3 onClick={this.forceReload}>We werken aan een oplossing voor dit probleem, klik hier om Plenda opnieuw te laden.</h3>
                </div>
            );
        } else {
            //when there's not an error, render children untouched
            return this.props.children;
        }
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Authentication));